import React, { FC } from 'react';
import { View } from 'react-native';

import { Body1Reg, Caption1Bold, Title3 } from '../../../config/designSystem/typography';
import { COLORS, Gradient } from '../../../config/designSystem/Colors';
import { ExerciseIllustration } from '../../Activity/ExerciseIllustration';
import { SPACING } from '../../../config/designSystem/Spacing';

/** deep plum card background from the memo design */
const CARD_BACKGROUND = '#472850';

export interface MemoCardContent {
  overline?: string;
  title?: string;
  body?: string;
  emoji?: string;
}

interface MemoCardProps {
  card: MemoCardContent;
  /** module gradient used for the illustration tile */
  tileGradient: Gradient;
}

/**
 * figma: Memo Card (Activities & Challenges pt1)
 * A deep-plum card with an illustration tile (figma: Exercise Illustration),
 * overline, title and body.
 */
export const MemoCard: FC<MemoCardProps> = ({ card, tileGradient }) => {
  return (
    <View
      style={{
        backgroundColor: CARD_BACKGROUND,
        borderRadius: SPACING['sp-24'],
        padding: SPACING['sp-32'],
        rowGap: SPACING['sp-16'],
        minHeight: 420,
      }}
    >
      <View style={{ alignSelf: 'center', marginBottom: SPACING['sp-8'] }}>
        <ExerciseIllustration emoji={card.emoji} gradient={tileGradient} />
      </View>
      {card.overline ? (
        <Caption1Bold color={'rgba(255,255,255,0.7)'}>{card.overline}</Caption1Bold>
      ) : null}
      {card.title ? (
        <Title3 color={COLORS.surface.contrast}>{card.title}</Title3>
      ) : null}
      {card.body ? (
        <Body1Reg color={'rgba(255,255,255,0.9)'}>{card.body}</Body1Reg>
      ) : null}
    </View>
  );
};
